module.exports = __webpack_public_path__ + "static/media/taxi_symbol.ca165c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/parking_icons/taxi_symbol.png
// module id = 1282
// module chunks = 0 1